import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthModule from './AuthModule';
import Header from './Header';
import '../styles/Feed.css';

const STORIES = [
  {
    id: 'the-office',
    title: 'A Nightmare at Dubey Mittal Paper Company',
    description: 'The employees of a small paper company in Jabalpur are terrified by the land their office is built upon',
    image: '/assets/story-images/the-office.PNG'
  },
  {
    id: '3idiots-horrorified',
    title: '3 Idiots ( Horrorified )',
    description: 'Farhan Qureshi is surprised to find a text from an old college alumini one night, claiming to meet their fugitive batchmate - Rancho',
    image: '/assets/story-images/3idiots-horrorified.JPG'
  },
  {
    id: 'family-vacation-in-darjeeling',
    title: 'Family Vacation in Darjeeling',
    description: 'A story of an IAS officer and his family who disappear while vacationing in Darjeeling after they fail to listen to the warnings of the caretaker of the vacation bungalow',
    image: '/assets/story-images/family-vacation-in-darjeeling.JPG'
  },
  {
    id: 'meeting-her-parents',
    title: 'Meeting Her Parents in Sagar ( M.P )',
    description: 'A story of a man who meets the parents of the woman he loves in the small town of Sagar, Madhya Pradesh',
    image: '/assets/story-images/meeting-her-parents.JPG'
  },
  {
    id: 'dragged-to-the-depths',
    title: 'Dragged to the Depths',
    description: 'A story of an abandoned lake and a recurring dream where a mysterious woman drags a man to the lake',
    image: '/assets/story-images/dragged-to-the-depths.JPG'
  },
  {
    id: 'bhura-ettan',
    title: 'The Strange Life of Bhura Ettan',
    description: 'A story of a small village in Kerala where villagers start dying mysteriously after a migrant from another state moves in',
    image: '/assets/story-images/bhura-ettan.JPG'
  },
  {
    id: 'strange-wedding',
    title: 'The Strange Wedding of Dhar',
    description: 'A story of a strange wedding procession that takes place every month around midnight in the city of Dhar',
    image: '/assets/story-images/strange-wedding.JPG'
  },
  {
    id: 'jadhav-mahal',
    title: 'The Painters of Jadhav Mahal',
    description: 'A story of blood relatives, ancient ruins, paintings, and the unexpected',
    image: '/assets/story-images/jadhav-mahal.JPG'
  },
  {
    id: 'barfi-bazaar',
    title: 'Barfi Bazaar',
    description: 'A chilling tale of the night guests at a traditional Indian sweets market',
    image: '/assets/story-images/barfi-bazaar.JPEG'
  },
  {
    id: 'fitness-center',
    title: 'The 24/7 Fitness Center',
    description: 'A story of ambition, friendship, and unexpected challenges',
    image: '/assets/story-images/fitness-center.JPEG'
  }
];

function Feed() {
  const [showAuth, setShowAuth] = useState(false);

  return (
    <div className="container">
      <Header onLoginClick={() => setShowAuth(true)} />

      <div className="feed-container">
        <div className="stories-grid">
          {STORIES.map(story => (
            <Link to={`/story/${story.id}`} key={story.id} className="story-card">
              <div className="story-image-container">
                <img src={story.image} alt={story.title} className="story-image" />
              </div>
              <div className="story-info">
                <h2>{story.title}</h2>
                <p>{story.description}</p>
              </div>
            </Link>
          ))}
        </div>

        {showAuth && (
          <div className="auth-popup-overlay" onClick={() => setShowAuth(false)}>
            <div className="auth-popup" onClick={e => e.stopPropagation()}>
              <AuthModule />
              <button className="close-auth" onClick={() => setShowAuth(false)}>×</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Feed; 